export const MENU_ITEMS = [
    { name: 'studyBrowser', label: 'Study Browser', path: '/' },
    { name: 'reports', label: 'Analytics', path: '/analytics' },
    { name: 'changePassword', label: 'Change Password', path: '/change-password' },
    { name: 'auditLogs', label: 'Activity Logs', path: '/activity-logs' },
    { name: 'userManagement', label: 'User Management', path: '/user-management' },
  ];
  